import React from "react";

// Domino-style "incognito" mask. From the Quick chat spec.
export const MaskGlyph = ({ size = 14, color = "currentColor", style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
    aria-hidden="true"
  >
    <path d="M3 12c2-3 6-4 9-4s7 1 9 4c-1 2-3 4-5 4-2 0-3-1-4-2-1 1-2 2-4 2-2 0-4-2-5-4z" />
    <circle cx="8.5" cy="12.5" r="1.2" fill={color} />
    <circle cx="15.5" cy="12.5" r="1.2" fill={color} />
  </svg>
);

// Lightning bolt for the "Faster · not saved" sublabel.
export const BoltGlyph = ({ size = 9, color = "currentColor", style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    style={style}
    aria-hidden="true"
  >
    <path d="M13 2L3 14h7l-1 8 11-14h-7l0-6z" />
  </svg>
);
